import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SignupService } from '@app-services/signup/signup.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionService } from '@app-services/subscription/subscription.service';

@Component({
    selector: 'app-ilite-modal',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.css', '../ilite.component.scss']
  })
  export class IliteModalComponent implements OnInit {
    imgs: any = {
        zoology: 'zoology',
        physics: 'physics',
        chemistry: 'chemistry',
        botany: 'botany',
        mathematics: 'maths',
        science: 'physics'
    }
    public PackageDetails:any = {}
    constructor(private activeModal: NgbActiveModal,public signUpService: SignupService, private dialog: MatDialog, private gaService: GAnalyticsService, public subscriptionservice : SubscriptionService, public modalservice:NgbModal,) { 
    }
    ngOnInit(): void {
     console.log("hey") ;
    }
    ngAfterViewInit(){
    }
    
  Close() {
    this.activeModal.close(); 
   }
  }
  